export const CACHE_KEYS = {
  GET_THEME_LIST: "theme",
  GET_THEME: "getTheme",
  MASTER_TABLE: "master_table",
  ADMIN_MENU: "admin_menu",
  MASTER_COUNT: "master_count",
  BRANCH_SAMPLE_FILE: "branch_sample_file",
  ORGANISATION_NAME: "organisation_name",
  REPORTING_USER_LIST: "reporting_user_list",
  CATEGORIES_LIST: "categories_list",
  NEW_ROLE: "new_role",
  NEW_BRANCH: "new_branch",
  DEMO_ONBOARDING_EXCEL: "demo_onboarding_excel",
  END_TRAINING: "completeTraining",
  RAZORPAY: "razorpay",
  USER_DETAILS: "user_details",
  DISCREPANCY: "discrepancy",
  HEALTH_IC_LIST: "health_ic_list",
  OCCUPATIONS_LIST: "occupations_list",
  LIFE_INSURANCE_COMPANY_LIST: "lifeInsuranceCompanyList",
  GENERAL_IC_LIST: "general_ic_list",
  LIFE_IC_LIST: "life_ic_list",
  PAYMENT_UPLOAD_SAMPLE: "payment_upload_sample",
  STATES: "states",
  CITIES: "cities",
  ROLE_MASTER: "role_master",
  VERTICAL: "vertical",
  THEMES_LIST: "themes_list",
  PREFILL_OCR_DATA: "prefill_ocr_data",
  USER_DOCUMENT: "user_document",
  EXAM_QUESTIONS_SAMPLE_EXCEL: "exam_questions_sample_excel",
  HEREIDATRY_DOCUMENT: "generateHereditaryCertificate",
  USER_CERTIFICATE: "user_certificate",
  AGENT_MENU: "agent_menu",
  TRAINING_DOCS: "training_docs",
  START_TRAINING: "start_training",
  ENDORSEMENT_TYPES: "endorsement_types",
  PAYMENT_WAIVER: "payment_waiver",
  ENDORSEMENT_REGISTER_REQUEST: "endorsement_register_request",
  ENDORSEMENT_UPDATE: "endorsement_update",
  COMPOSITE_IC_LIST: "compositeInsuranceCompanies",
  GENERAL_INSURANCE_COMPANY_LIST: "generalInsuranceCompanyList",

  PAYMENT_STATUS: "PAYMENT_STATUS",
  PAYMENT_RECEIPT: "PAYMENT_RECEIPT",
  PAYMENT_RECEIPT_VIEW: "PAYMENT_RECEIPT_VIEW",

  GET_STATUS_TRACKING: "GET_STATUS_TRACKING",
  USER_DATA: "user",
  GET_BROKER_DETAILS: "getlogo",
  UPDATE_BROKER_DETAILS: "uploadlogo",
  UPDATE_USER: "updateUser",
  USER_LIST: "getUserList",
};
